/**
 * Client-side market price hook for service detail pages. Renders a neutral baseline
 * (service.price) during SSG/first paint, then — once the visitor's market resolves and
 * its catalog loads (via useMarketServices) — swaps to that market's displayPrice for this
 * service. Mirrors the market-swap pattern in src/pages/services.js.
 */
import { useEffect, useState } from 'react'
import { useMarketServices } from './useMarketServices'
import { formatCurrency } from './format'

/**
 * @param {{ id: string, price: number }} service
 * @returns {{ priceText: string, market: object|null }}
 */
export const useMarketPrice = service => {
  const { marketServices, market } = useMarketServices()
  const [priceText, setPriceText] = useState(formatCurrency(service.price))
  const priceDisplay = market?.priceDisplay

  useEffect(() => {
    if (!marketServices) {
      return
    }
    const match = marketServices.find(ms => ms.service?.id === service.id)
    if (!match) {
      return
    }
    const useDisplay = priceDisplay?.toLowerCase() !== 'base'
    const value = useDisplay ? match.displayPrice : match.price
    if (value == null) {
      return
    }
    setPriceText(formatCurrency(value))
  }, [marketServices, priceDisplay, service.id])

  return { priceText, market }
}
